import { render } from "./LinkedAccounts.vue?vue&type=template&id=831e1614"
import script from "./LinkedAccounts.vue?vue&type=script&lang=js"
export * from "./LinkedAccounts.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__